
import {
  CoreShareModal,
  UserAccountAuthModal,
  DigitizationProjectDownloadModal,
  DigitizationProjectMakePermanentModal,
  DigitizationProjectMadePermanentSuccessModal
} from '#components';
import {BACKDROP_BLUR_CLASS} from '~/constants/modals.js';

export function useDigitizationActions() {

  function shareProject({project}) {
    useFModal({
      id: 'digi-share-project',
      component: CoreShareModal,
      size: 'sm-md',
      props: {
        shareObject: project,
        shareType: 'digiProject',
      }
    }).open();
  }

  function shareFile({file}) {
    useFModal({
      id: 'digi-share-file',
      component: CoreShareModal,
      size: 'sm-md',
      props: {
        shareObject: file,
        shareType: 'digiFile',
      }
    }).open();
  }

  function makeProjectPermanent({project}) {
    const modalOptions = {
      id: 'digi-make-permanent',
      component: DigitizationProjectMakePermanentModal,
      size: 'md',
      props: {project}
    };

    if (project.userNeedsToBuyStorage) {
      useMarketingModal({
        ...modalOptions,
        size: 'lg',
        tracking: {
          type: UPSELL_TYPES.storage,
          context: STORAGE_UPSELL_CONTEXTS.digitizationProjectMakePermanent
        }
      }).open();
      return;
    }

    useFModal(modalOptions).open();
  }

  function projectMadePermanentSuccess({project}) {
    useFModal({
      id: 'digi-make-permanent',
      component: DigitizationProjectMadePermanentSuccessModal,
      clickToClose: false,
      size: 'md',
      props: {project}
    }).open();
  }

  async function makeCover({file, projectId}) {
    try {
      await useDigitizationStore().makeFileCover({projectId, file})
      useSuccessToast().add({
        description: `The file has been set as the cover for the project.`
      });
    } catch (e) {
      console.error('Error setting file as cover:', e);
      useErrorToast().add({
        description: 'We are unable to set this file as the cover for the project. Please try again later.'
      });
    }
  }

  function downloadProject({project}) {
    useFModal({
      id:  'digitization-project-download',
      //size: 'lg',
      component: DigitizationProjectDownloadModal,
      props: {project}
    }).open();
  }

  return {
    shareProject,
    shareFile,
    makeCover,
    makeProjectPermanent,
    projectMadePermanentSuccess,
    downloadProject
  };
}
